// components
import { CircularProgress } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

// types
import type { StepIconProps } from './StepIcon.types';

/** Where one step stands, at a glance; the running step spins so the list reads as alive. */
const StepIcon = ({ state }: StepIconProps) => {
  'use memo';

  switch (state) {
    case 'RUNNING':
      return <CircularProgress size={14} />;
    case 'DONE':
      return <Icon type="circle-check" color="success" fontSize="small" />;
    case 'FAILED':
      return <Icon type="circle-xmark" color="error" fontSize="small" />;
    case 'ATTENTION':
      return (
        <Icon type="triangle-exclamation" color="warning" fontSize="small" />
      );
    default:
      return <Icon type="circle" color="disabled" fontSize="small" />;
  }
};

export default StepIcon;
